import Vue from "vue";
import Vuex from "vuex";

import { featureFlagModule } from "./featureFlagModule";
import jiraQaImport from "./jiraQaImport";
import { autoAssignmentModule } from "./admin/autoAssignmentModule";
import adminDropdown from "./admin/dropdown";
import adminDropdownValue from "./admin/dropdownValue";
import adminRole from "./admin/role";
import adminServiceArea from "./admin/serviceArea";
import adminServiceAreaAttribute from "./admin/serviceAreaAttribute";
import adminServiceAreaCategory from "./admin/serviceAreaCategory";
import adminTags from "./admin/tag";
import adminUser from "./admin/user";
import application from "./application";
import auditLog from "./auditLog";
import dashboardServiceArea from "./dashboard/serviceArea";
import dropdown from "./dropdown";
import file from "./file";
import filter from "./filter";
import filterPreset from "./filterPreset";
import pack from "./pack";
import memberPack from "./memberPack";
import quickFilter from "./quickFilter";
import releaseNote from "./releaseNote";
import searchableField from "./searchableField";
import session from "./session";
import templates from "./templates";
import testPlan from "./testPlan";
import testStep from "./testStep";
import user from "./user";

Vue.use(Vuex);

const vuexStore = new Vuex.Store({
  modules: {
    admin: {
      modules: {
        dropdown: adminDropdown,
        dropdownValue: adminDropdownValue,
        role: adminRole,
        serviceArea: adminServiceArea,
        serviceAreaAttribute: adminServiceAreaAttribute,
        serviceAreaCategory: adminServiceAreaCategory,
        tag: adminTags,
        user: adminUser,
      },
      namespaced: true,
    },
    application,
    auditLog,
    dashboard: {
      modules: {
        serviceArea: dashboardServiceArea,
      },
      namespaced: true,
    },
    dropdown,
    autoAssignment: autoAssignmentModule,
    featureFlag: featureFlagModule,
    file,
    jiraQaImport,
    memberPack,
    filter,
    filterPreset,
    pack,
    quickFilter,
    releaseNote,
    searchableField,
    session,
    templates,
    testPlan,
    testStep,
    user,
  },
});

if (window.Cypress) {
  window.__store__ = vuexStore;
}

export default vuexStore;
